module.exports = __webpack_public_path__ + "img/collection-engagementRingsTensionRing@2x.f604f57.webp";